<template>
  <div>
    <v-layout class="p-4 pr-0 border-bottom-light-grey min-height-57px">
      <v-flex class="d-flex font-level-3-bold my-auto">
        <span class="detail-svg-icon mr-2">
          <!--begin::Svg Icon-->
          <!--  <v-icon color="blue darken-4">mdi-cart</v-icon> -->
          <span class="svg-icon svg-icon-lg mr-2 svg-v-list-icon">
            <!--end::Svg Icon-->
          </span>
        </span>
        <span class="form-title font-size-20 font-weight-700">Claim List</span>
      </v-flex>
      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            style="max-height: 40px !important"
            v-bind="attrs"
            v-on="on"
            :disabled="pageLoading"
            class="mx-2 custom-bold-button"
            color="cyan white--text"
            @click="exportCliam()"
          >
            <v-icon dark left dense>mdi-database-export</v-icon>
          </v-btn>
        </template>
        <span>Export Claim</span>
      </v-tooltip>

      <v-text-field
        style="max-width: 250px !important"
        v-model.trim="search"
        v-on:click:clear="clearFilter('search')"
        clearable
        dense
        filled
        flat
        placeholder="Search"
        hide-details
        solo
        :disabled="pageLoading"
        :loading="pageLoading"
        color="cyan"
        @keydown.enter="getDriverClaimList"
        @keydown.tab="getDriverClaimList"
      ></v-text-field>
      <v-select
        style="max-width: 250px !important"
        :disabled="pageLoading"
        :loading="pageLoading"
        :items="statusList"
        v-model="status"
        hide-details
        flat
        solo
        dense
        placeholder="Status"
        color="cyan"
        item-color="cyan"
        class="pt-0 mt-0"
        item-text="text"
        item-value="status"
        clearable
        v-on:change="getDriverClaimList"
        v-on:click:clear="clearFilter('status')"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-avatar size="20">
              <v-chip :color="item.color" text-color=""> </v-chip>
            </v-avatar>
          </v-list-item-action>
        </template>
      </v-select>
      <div style="width: 300px !important; min-width: 250px !important">
        <v-menu
          v-model="datePicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              filled
              flat
              label="Date Range"
              hide-details
              solo
              :loading="pageLoading"
              :disabled="pageLoading"
              v-on:click:clear="clearFilter('dates')"
              clearable
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              :value="formattedDate"
              color="cyan"
            ></v-text-field>
          </template>
          <v-date-picker
            color="cyan"
            range
            :disabled="pageLoading"
            v-on:change="getDriverClaimList"
            v-model="dates"
          ></v-date-picker>
        </v-menu>
      </div>
    </v-layout>
   
    <ListingTable :columnCount="8" :rowData="claimList"  :dataLoading="pageLoading">
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">Claim #</th>
            <th class="simple-table-th">Transport #</th>
            <th class="simple-table-th">Claim Category</th>
            <th class="simple-table-th">Date of Claim</th>
            <th class="simple-table-th">Consumption Amount</th>
            <th class="simple-table-th">Top-up Amount</th>
            <th class="simple-table-th">Attachments</th>
            <th class="simple-table-th">Status</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="claimList.length">
            <tr
              v-for="(row, index) in claimList"
              :key="index"
              v-on:click="routeToInvoice(row)"
            >
              
              <td class="simple-table-td">
                <p class="m-0 custom-nowrap-ellipsis">
                    <Barcode small :barcode="row.barcode"></Barcode>
                </p>
              </td>
              <td class="simple-table-td">
                <div class="invoice-listing-customer">
                 <p class="m-0 custom-nowrap-ellipsis" v-on:click="detailDelivery(row?.delivery)">
                    <template v-if="row?.delivery?.barcode">
                    <Barcode
                      small
                      :barcode="row?.delivery?.barcode"
                      :id="row?.delivery?.id"
                    ></Barcode>
                    </template>
                    <em v-else class="text-muted">no Transport #</em>
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <div class="invoice-listing-amount">
                 <template v-if="row.category">
                    <b>{{ row.category }}</b>
                  </template>
                  <em v-else class="text-muted">no category</em>
                </div>
              </td>
              <td class="simple-table-td">
                <b>{{ formatDate(row.added_at) }}</b>
              </td>

               <td class="simple-table-td">
               <template v-if="row.amount > 0">
                    <span class="font-weight-700">
                      {{ formatMoney(row.amount) }}</span
                    >
                  </template>
                  <em v-else class="text-muted">no Consumption Amount</em>
              </td>
               <td class="simple-table-td">
                <template v-if="row.top_up_amount > 0">
                    <span class="font-weight-700">
                      {{ formatMoney(row.top_up_amount) }}</span
                    >
                  </template>
                  <em v-else class="text-muted">no top-up amount</em>
              </td>
               <td class="simple-table-td">
                <template v-if="row?.documents?.length > 0">
                    <template v-for="(attach, index) in row?.documents">
                      <v-icon
                        color="blue"
                        :key="index"
                        v-on:click="download(attach?.file?.url)"
                        class="mr-2"
                        size="25"
                      >
                        mdi-download
                      </v-icon>
                    </template>
                  </template>
                  <em v-else class="text-muted">no attachment </em>
              </td>
               <td class="simple-table-td">
                <template v-if="statusList && statusList?.length > 0">
                    <v-menu
                      offset-y
                      min-width="100px"
                      style="padding: 0px 4px"
                      rounded
                      bottom
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="d-flex justify-space-between align-center"
                          style="
                            padding: 0px 6px;
                            background-color: #f7faff;
                            width: 150px;
                            border-radius: 9px;
                          "
                          :style="`border:1px solid ${getStatusColor(
                            row.status
                          )}`"
                        >
                          <span
                            :class="`text-capitalize font-level-1 ${getStatusText(
                              row.status
                            )}`"
                          >
                            <template v-if="row.status == 1"> Pending</template>
                            <template v-else-if="row.status == 2">
                              Approved</template
                            >
                            <template v-else-if="row.status == 3">
                              Rejected</template
                            >
                          </span>
                          <v-icon
                            style="font-size: 22px"
                            :color="getStatusColor(row.status)"
                            small
                            >mdi-menu-down</v-icon
                          >
                        </div>
                      </template>

                      <v-list elevation>
                        <v-list-item
                          v-on:change="updateStatus(item.status, row)"
                          class="list-item cursor-pointer p-1"
                          v-for="(item, index) in statusList"
                          :key="index"
                        >
                          <v-list-item-title class="pl-1">
                            <v-chip
                              style="height: 15px; width: 15px; padding: 0"
                              :color="item.color"
                            >
                            </v-chip>
                            {{ item.text }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
              </td>

              
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="8">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no claims at the moment.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </ListingTable>
    <ListingFooter
      :dataLoading="pageLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
    ></ListingFooter>
  </div>
</template>
 
<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { QUERY, PATCH } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import JwtService from "@/core/services/jwt.service";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
export default {
  name: "driverDemritPoints",
  mixins: [CommonMixin, ValidationMixin],
  props: {
    driver: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      currentPage: 1,
      search: null,
      totalPages: 0,
      totalRows: 0,
      rowsOffset: 0,
      claimList: [],
      pageLoading: false,
      status: null,
      dates: [],
      statusList: [
        {
          text: "Pending",
          status: "1",
          color: "orange",
        },
        {
          text: "Approved",
          status: "2",
          color: "green",
        },
        {
          text: "Rejected",
          status: "3",
          color: "red",
        },
      ],
    };
  },
  watch: {
    driver: {
      handler(driver) {
        if (driver) {
          this.getDriverClaimList();
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    getDriverClaimList() {
      const data = {
        current_page: this.currentPage,
        status: this.status ?? null,
        search: this.search ?? null,
        dates: this.dates ?? null,
      };

    /*   if (this.pageLoading) {
        return false;
      } */

      this.pageLoading = true;

      this.$store
        .dispatch(QUERY, { url: `driver/${this.driver}/expense`, data: data })
        .then(({ data }) => {
             console.log(data)
          this.totalPages = Math.ceil(data.total_rows / data.per_page);
          this.currentPage = data.current_page;
          this.claimList = data.rows;
          this.totalRows = data.total_rows;
       
          this.rowsOffset = data.offset;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    exportCliam() {
      let downloadURL = process.env.VUE_APP_API_URL + "engineer/claim";
      downloadURL = new URL(downloadURL);

      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      this.lodash.map(this.queryParams, function (row, index) {
        downloadURL.searchParams.append(index, row);
      });

      downloadURL.searchParams.append("driver", this.driver ?? 0);
      downloadURL.searchParams.append("status", this.status ?? 0);
      if (this.search) {
        downloadURL.searchParams.append("search", this.search);
      }

      if (this.dates && this.dates[0]) {
        downloadURL.searchParams.append("dates[0]", this.dates[0]);
      }
      if (this.dates && this.dates[1]) {
        downloadURL.searchParams.append("dates[1]", this.dates[1]);
      }
      window.open(downloadURL, "_blank");
    },
    updateStatus(status, data) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "expense/" + data.id + "/status/" + status,
        })
        .then(() => {
          _this.getDriverClaimList();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getDriverClaimList();
          _this.pageLoading = false;
        });
    },
    getStatusColor(data) {
      if (data == 1) {
        return "orange";
      } else if (data == 2) {
        return "green";
      } else if (data == 3) {
        return "red";
      }
    },
    getStatusText(data) {
      if (data == 1) {
        return "orange--text";
      } else if (data == 2) {
        return "green--text";
      } else if (data == 3) {
        return "red--text";
      }
    },
    download(url) {
      if (!url) {
        return false;
      }
      window.open(url, "_blank");
    },
    detailDelivery(data) {
      let routeName = null;
      if (data?.type == "incoming") {
        routeName = "incoming-delivery.detail";
      } else if (data?.type == "outgoing") {
        routeName = "outgoing-delivery.detail";
      } else if (data?.type == "transfer") {
        routeName = "transfer-delivery.detail";
      }
      this.$router.push(
        this.getDefaultRoute(routeName, {
          params: {
            id: data?.id,
          },
        })
      );
    },
    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.search = null;
          break;
        case "status":
          _this.status = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      _this.getDriverClaimList();
    },
   
  },
  computed: {
     showingFrom() {
      return this.lodash.isEmpty(this.claimList) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.claimList ? this.claimList.length : 0);
    },
  },
  components: {
    Barcode,
    ListingFooter,
    ListingTable
  },
  mounted() {
    this.getDriverClaimList();
  },
};
</script>
